<template>
  <div class="user-verify">
    <div class="content-item" v-if="workFlowData.type !== 'task'">
      <div class="item-title">
        审批对象
        <span class="require-flag">*</span>
      </div>
      <tree-select
        class="item-select"
        v-model="tempNodeData.dataVar"
        :group-list="simpleWorkflowVarList"
        @input="getSheetId"
      ></tree-select>
    </div>

    <template v-if="!_.isEmpty(flowConnectedData)">
      <sheet-verify
        v-if="workFlowData.type !== 'task'"
        ref="SheetVerify"
        :people-group="flowConnectedData | screenPeople"
        :flow-info="nodeInfo"
        :app-id="workFlowData.appId"
      ></sheet-verify>

      <task-verify
        v-else
        ref="TaskVerify"
        :people-group="flowConnectedData | screenPeople"
        :flow-info="nodeInfo"
        :project-id="workFlowData.appId"
      ></task-verify>
    </template>

    <div class="content-item">
      <div class="item-title">审批类型</div>
      <el-radio-group v-model="tempNodeData.or" class="mTop10">
        <el-radio :label="true">或签</el-radio>
        <el-radio :label="false">多人会签</el-radio>
      </el-radio-group>
    </div>

    <div class="content-item" v-if="workFlowData.type !== 'task' && controls && controls.length">
      <div class="item-title">
        审批内容
        <span class="require-flag">*</span>
      </div>
      <verify-content
        ref="verifyContent"
        :sheet-id="tempNodeData.sheetId"
        :temp-data="tempNodeData"
        :fields-info-map="fieldsInfoMap"
      ></verify-content>
    </div>

    <div class="content-item">
      <div class="item-title">
        审批建议
        <el-tooltip content="指导审批人如何进行审批" placement="bottom-start">
          <span class="icon-tip pointer">
            <i class="el-icon-info"></i>
          </span>
        </el-tooltip>
      </div>
      <verify-items
        ref="verifyItems"
        :verify-items="tempNodeData.verifyItems"
        @addItem="tempNodeData.verifyItems.push('')"
        @deleteItem="i => tempNodeData.verifyItems.splice(i, 1)"
      ></verify-items>
    </div>
    <div class="content-item">
      <div class="item-title">
        按钮名称
        <span class="require-flag">*</span>
      </div>
      <div class="sub-item">
        <div class="label">同意按钮</div>
        <el-input
          v-model="tempNodeData.acceptButtonName"
          placeholder="请填写按钮名称，不超过6个字符"
          :maxlength="6"
        ></el-input>
      </div>
      <div class="sub-item">
        <div class="label">驳回按钮</div>
        <el-input
          v-model="tempNodeData.rejectButtonName"
          placeholder="请填写按钮名称，不超过6个字符"
          :maxlength="6"
        ></el-input>
      </div>
    </div>
    <div class="content-item" v-if="workFlowData.type !== 'task'">
      <div class="item-title">
        审批意见
      </div>
      <div class="sub-item" v-if="tempNodeData.acceptFillCids">
        <div class="label">同意时</div>
        <verify-advice
          ref="verifyContent"
          :sheet-id="tempNodeData.sheetId"
          :temp-data="tempNodeData"
          :fields-info-map="fieldsInfoMap"
        ></verify-advice>
      </div>
      <div class="sub-item">
        <div class="label">驳回时</div>
        <div class="sub-content">
          <div v-for="reject in tempNodeData.rejectFillCids" :key="reject.cid" class="field-item">
            <span v-tip class="name">
              {{ fieldsInfoMap[reject.cid] || "字段已删除" }}
            </span>
            <div class="actionList pointer">
              <span :class="{ active: reject.type == 'R' }" @click="reject.type = 'R'">
                隐藏
              </span>
              <span :class="{ active: reject.type == 'W' }" @click="reject.type = 'W'">
                填写
              </span>
              <span :class="{ active: reject.type == 'H' }" @click="reject.type = 'H'">
                必填
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-item">
      <div class="item-title">
        站内消息通知
        <span class="require-flag">*</span>
      </div>
      <textarea-editor
        class="item-text"
        v-model="richTextObj"
        :var-group="varGroupList"
        min-height="160"
        max-height="400"
      ></textarea-editor>
    </div>
    <div class="content-item">
      <div class="item-title">
        <el-checkbox v-model="tempNodeData.canChangeCandidate">允许审批人：更换审批人</el-checkbox>
      </div>
    </div>
    <div class="content-item">
      <div class="item-title">
        <el-checkbox v-model="tempNodeData.canCancel">允许发起人：撤销审批</el-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import { deepClone } from "@/utils/common"
import TreeSelect from "@/components/UIComponents/TreeSelect"
import SheetVerify from "./SetPeople/SheetVerify"
import TaskVerify from "./SetPeople/TaskVerify"
import VerifyContent from "@/views/Backend/AdminEdit/Workflow/components/settingWorkflow/components/verifyContent"
import VerifyItems from "@/views/Backend/AdminEdit/Workflow/components/settingWorkflow/components/verifyItems"
import TextareaEditor from "@/components/UIComponents/TextareaEditor"
import Filters from "../../../mixin/filters"
import { getAllDefaultControls, getSimpleSheetList } from "@/api/sheet/sheet"
import { filterTreeVarGroup, transOldExpr } from "@/utils/workFlow"
import VerifyAdvice from "@/views/Backend/AdminEdit/Workflow/components/settingWorkflow/components/verifyAdvice"

export default {
  name: "userVerify",
  components: {
    VerifyAdvice,
    TreeSelect,
    SheetVerify,
    VerifyContent,
    VerifyItems,
    TextareaEditor,
    TaskVerify
  },
  props: {
    nodeInfo: Object,
    flowConnectedData: Array,
    groupList: Array,
    workFlowData: Object,
    workFlowControlMap: Object,
    availableSheets: Array
  },
  mixins: [Filters],
  data() {
    return {
      tempNodeData: {},
      richTextObj: {},
      sheetListMap: {},
      controlTypeMap: {}
    }
  },
  computed: {
    simpleWorkflowVarList() {
      return filterTreeVarGroup({
        varGroup: this.groupList,
        filterFunc: ({ control }) => control._type === "ref" && control.oneFlag
      })
    },
    controls() {
      return this.sheetListMap?.[
        this.workFlowControlMap?.[this.tempNodeData.dataVar]?.refSheetId
      ]?.controls.map(control => ({ label: control.name, value: control._cid }))
    },
    varGroupList() {
      return filterTreeVarGroup({
        varGroup: this.groupList,
        filterFunc: option => option.strValue,
        mapFunc: option => Object.assign({}, option, { value: option.strValue })
      })
    },
    fieldsInfoMap() {
      let result = this.availableSheets
        .flatMap(app => app.sheets)
        .flatMap(sheet => sheet.controls)
        .reduce(
          (acc, cur) =>
            Object.assign(acc, { [cur._cid]: `[${this.controlTypeMap[cur._type]}] ${cur.name}` }),
          {}
        )
      result["verifyComments"] = "[系统] 审批意见"
      result["verifySign"] = "[系统] 审批签名"
      return result
    }
  },
  created() {
    if (this.workFlowData.type !== "task") {
      getSimpleSheetList(this.workFlowData.appId).then(
        sheetList => (this.sheetListMap = this._.keyBy(sheetList, "sheetId"))
      )
      getAllDefaultControls().then(
        controls =>
          (this.controlTypeMap = controls.reduce(
            (acc, cur) => Object.assign(acc, { [cur._type]: cur.name }),
            {}
          ))
      )
    }
  },
  methods: {
    init() {
      this.nodeInfo.data.dataVar = transOldExpr(this.nodeInfo.data.dataVar)
      this.nodeInfo.data.originatorUserId = transOldExpr(this.nodeInfo.data.originatorUserId)
      this.nodeInfo.data.candidates = this.nodeInfo.data.candidates?.map(candidate => {
        candidate.code = transOldExpr(candidate.code)
        return candidate
      })
      this.tempNodeData = deepClone(this.nodeInfo).data
      if (!this._.keys(this.tempNodeData).includes("verifyContents"))
        this.$set(this.tempNodeData, "verifyContents", [])

      // 兼容老数据
      if (this._.isEmpty(this.tempNodeData.acceptFillCids))
        this.tempNodeData.acceptFillCids = [
          {
            cid: "verifyComments",
            type: "W",
            subList: []
          },
          {
            cid: "verifySign",
            type: "W",
            subList: []
          }
        ]
      if (this._.isEmpty(this.tempNodeData.rejectFillCids))
        this.tempNodeData.rejectFillCids = [
          {
            cid: "verifyComments",
            type: "H",
            subList: []
          },
          {
            cid: "verifySign",
            type: "R",
            subList: []
          }
        ]
      if (this.nodeInfo.extra?.textarea) {
        this.richTextObj = {
          text: this.nodeInfo.data.content,
          arr: this.nodeInfo.extra.textarea
        }
      }
    },
    getSheetId() {
      this.tempNodeData.sheetId = this.workFlowControlMap?.[this.tempNodeData.dataVar]?.refSheetId
      this.tempNodeData.fillCids = []
    }
  }
}
</script>

<style lang="scss">
.user-verify {
  .content-item {
    font-size: 13px;
    &:not(:first-child) {
      .item-title {
        margin-top: 18px;
      }
    }
    .item-title {
      font-weight: bold;
      .el-checkbox__label {
        font-size: 13px;
      }
      .require-flag {
        color: red;
        font-size: 22px;
        position: relative;
        top: 3px;
      }
    }
    .sub-item {
      .label {
        margin: 10px 0;
      }
      .sub-content {
        .field-item {
          flex: 1;
          display: flex;
          align-items: center;
          height: 36px;
          margin-bottom: 10px;
          margin-right: 24px;
          .name {
            flex: 1 1;
            padding: 0 12px;
            background: #f8f8f8;
            color: #333;
            border-radius: 4px;
            height: 36px;
            line-height: 36px;
          }
          .actionList {
            width: 160px;
            display: flex;
            margin: 0 10px 0 7px;
            box-sizing: border-box;
            background: #f8f8f8;
            span {
              color: #757575;
              line-height: 36px;
              display: inline-block;
              text-align: center;
              flex: 1 1;
              &.active {
                color: #2196f3;
              }
            }
          }
        }
      }
    }
    .item-select {
      margin-top: 10px;
    }
    .item-text {
      margin-top: 10px;
    }
  }
}
</style>
